import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { QuickListItem } from '../sagas/announcementSlice';

interface ActiveQuickListButtonProps {
  item: QuickListItem;
  onRemove: (item: QuickListItem) => void;
}

export const ActiveQuickListButton = ({ item, onRemove }: ActiveQuickListButtonProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px 16px',
        borderRadius: '10px',
        border: '2px solid #ddd',
        position: 'relative',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
      }}
    >
      <IconButton
        sx={{
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          padding: 0,
          backgroundColor: 'white',
          borderRadius: '50%',
          border: '1px solid #bbb',
          '&:hover': {
            border: '2px solid #39A2DB',
          },
        }}
        onClick={() => onRemove(item)}
      >
        <CloseIcon
          sx={{
            color: '#bbb',
            fontSize: '16px',
            '&:hover': {
              color: '#39A2DB',
            },
          }}
        />
      </IconButton>

      <Typography variant="body2" sx={{ textAlign: 'center', fontWeight: 'bold' }}>
        {item.label}
      </Typography>
    </Box>
  );
};
